import styled from 'styled-components';
import type { InsightHeadingBlock } from '../../types';

const Wrap = styled.section`
  display: grid;
  gap: 0.75rem;
  max-width: 46rem;
  margin: 0 auto;
`;

const Eyebrow = styled.span<{ $accent: string }>`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.76rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  font-weight: 800;
  color: ${({ $accent }) => $accent};
`;

const HeadingTwo = styled.h2<{ $ink: string }>`
  margin: 0;
  font-family: var(--font-serif);
  font-size: clamp(1.9rem, 3.4vw, 3rem);
  line-height: 1;
  letter-spacing: -0.035em;
  color: ${({ $ink }) => $ink};
`;

const HeadingThree = styled.h3<{ $ink: string }>`
  margin: 0;
  font-family: var(--font-serif);
  font-size: clamp(1.45rem, 2.6vw, 2rem);
  line-height: 1.06;
  letter-spacing: -0.03em;
  color: ${({ $ink }) => $ink};
`;

type HeadingBlockProps = {
  block: InsightHeadingBlock;
  accent: string;
  ink: string;
};

export default function HeadingBlock({ block, accent, ink }: HeadingBlockProps) {
  return (
    <Wrap>
      {block.eyebrow ? <Eyebrow $accent={accent}>{block.eyebrow}</Eyebrow> : null}
      {block.level === 3 ? (
        <HeadingThree $ink={ink}>{block.text}</HeadingThree>
      ) : (
        <HeadingTwo $ink={ink}>{block.text}</HeadingTwo>
      )}
    </Wrap>
  );
}
